import { cn } from "@/lib/utils";

interface LegalDisclaimerProps {
  variant?: "full" | "compact" | "inline";
  className?: string;
  showTitle?: boolean;
}

export function LegalDisclaimer({ 
  variant = "full", 
  className,
  showTitle = true 
}: LegalDisclaimerProps) {
  if (variant === "inline") {
    return (
      <p className={cn("text-xs text-muted-foreground", className)}>
        Apoio técnico independente. Não substituímos inspeções legais obrigatórias nem certificações oficiais.
      </p>
    );
  }

  if (variant === "compact") {
    return (
      <div className={cn("text-xs text-muted-foreground space-y-2 pt-4 border-t border-border", className)}>
        <p>
          A ElevAdvisor não atua como entidade certificadora, auditor oficial ou engenheiro responsável, nem substitui inspeções legais obrigatórias.
        </p>
        <p>
          As inspeções realizadas destinam-se exclusivamente ao apoio técnico e à elaboração de relatórios, não constituindo certificação nem parecer legal vinculativo.
        </p>
      </div>
    );
  }

  // Full variant
  return (
    <div className={cn("text-sm text-muted-foreground space-y-4 p-6 bg-muted/30 rounded-lg border border-border", className)}>
      {showTitle && (
        <h3 className="font-semibold text-foreground">Nota de Confiança</h3>
      )}
      
      <p>
        A ElevAdvisor é uma plataforma independente de apoio técnico à gestão de edifícios, especializada na interpretação de documentação técnica e normativa, bem como na realização de inspeções técnicas aos equipamentos e instalações.
      </p>
      
      <div>
        <p className="font-medium text-foreground mb-2">O nosso apoio técnico inclui:</p>
        <ul className="list-disc list-inside space-y-1 ml-2">
          <li>Interpretação de normas, contratos e documentação técnica</li>
          <li>Inspeções físicas aos equipamentos e instalações, com recolha de evidência técnica</li>
          <li>Análise do estado, riscos e prioridades de intervenção</li>
          <li>Elaboração de relatórios técnicos independentes</li>
          <li>Apoio à tomada de decisões informadas por parte de gestores e responsáveis de edifícios</li>
        </ul>
      </div>
      
      <p>
        Atuamos sempre do lado do cliente, de forma independente e sem qualquer vínculo a empresas de manutenção.
      </p>
      
      <div className="pt-4 border-t border-border space-y-2 text-xs">
        <p>
          A ElevAdvisor não atua como entidade certificadora, auditor oficial ou engenheiro responsável, nem substitui inspeções legais obrigatórias.
        </p>
        <p>
          As inspeções realizadas destinam-se exclusivamente ao apoio técnico e à elaboração de relatórios, não constituindo certificação nem parecer legal vinculativo.
        </p>
        <p>
          A responsabilidade técnica e legal formal permanece no âmbito dos profissionais e entidades legalmente habilitados.
        </p>
      </div>
    </div>
  );
}

export default LegalDisclaimer;
